import { RequestStatus } from '../enums/request-status.enum';

export interface FileDetail {
  id: number;
  fileName: string;
  status: RequestStatus;
  fileStatusName: string;
  checkCount: number;
  ddaCount: number;
  docsInFile: number;
  totalAmountOfDocs: number;
  fileNumber: string;
  readyToProcess: boolean;
}

export interface FileDetailTotals {
  checkCount: number;
  ddaCount: number;
  docsInFile: number;
  totalAmountOfDocs: number;
}

export function calculateFileDetailTotals(
  fileDetails: FileDetail[]
): FileDetailTotals {
  return fileDetails.reduce(
    (totals, file) => ({
      checkCount: totals.checkCount + file.checkCount,
      ddaCount: totals.ddaCount + file.ddaCount,
      docsInFile: totals.docsInFile + file.docsInFile,
      totalAmountOfDocs: totals.totalAmountOfDocs + file.totalAmountOfDocs,
    }),
    { checkCount: 0, ddaCount: 0, docsInFile: 0, totalAmountOfDocs: 0 }
  );
}
